import ClientList from 'containers/client/client-list'
import ClientEdit from 'containers/client/client-edit'
import ClientFacilityList from 'containers/client-facility/client-facility-list'
import ClientFacilityEdit from 'containers/client-facility/client-facility-edit'
import ClientDosemeterAdd from 'containers/client-dosemeter/dosemeter-add'
import ClientDosemeterEdit from 'containers/client-dosemeter/dosemeter-edit'
import ClientDosemeterMeasurementList from 'containers/client-dosemeter-measurement/measurement-list'
import ClientMeasurementReportList from 'containers/client-measurement-report/report-list'
import ClientAccountList from 'containers/client-account/client-account-list'
import ClientAccountEdit from 'containers/client-account/client-account-edit'
import {
  PATH_CLIENT_LIST, PATH_CLIENT_ADD, PATH_CLIENT_EDIT,
  PATH_CLIENT_FACILITY_LIST, PATH_CLIENT_FACILITY_ADD, PATH_CLIENT_FACILITY_EDIT,
  PATH_CLIENT_MEASUREMENTS, PATH_CLIENT_MEASUREMENT_REPORTS,
  PATH_CLIENT_DOSEMETER_ADD, PATH_CLIENT_DOSEMETER_EDIT,
  PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST, PATH_CLIENT_MEASUREMENT_REPORT_LIST,
  PATH_CLIENT_ACCOUNT_LIST, PATH_CLIENT_ACCOUNT_ADD, PATH_CLIENT_ACCOUNT_EDIT,
} from 'routing/path'

const clientRoutes = [
  { path: PATH_CLIENT_LIST, component: ClientList },
  { path: PATH_CLIENT_ADD, component: ClientEdit },
  { path: PATH_CLIENT_EDIT + ":id", component: ClientEdit },
  { path: PATH_CLIENT_FACILITY_LIST, component: ClientFacilityList },
  { path: PATH_CLIENT_FACILITY_ADD + ":clientId", component: ClientFacilityEdit },
  { path: PATH_CLIENT_FACILITY_EDIT + ":clientFacilityId", component: ClientFacilityEdit },
  { path: PATH_CLIENT_MEASUREMENTS + ":id", component: ClientDosemeterMeasurementList },
  { path: PATH_CLIENT_MEASUREMENT_REPORTS + ":id", component: ClientMeasurementReportList },
  { path: PATH_CLIENT_DOSEMETER_ADD + ":clientId/:dosemeterType", component: ClientDosemeterAdd },
  { path: PATH_CLIENT_DOSEMETER_EDIT + ":clientDosemeterId", component: ClientDosemeterEdit },
  { path: PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST, component: ClientDosemeterMeasurementList },
  { path: PATH_CLIENT_MEASUREMENT_REPORT_LIST, component: ClientMeasurementReportList },
  { path: PATH_CLIENT_ACCOUNT_LIST, component: ClientAccountList },
  { path: PATH_CLIENT_ACCOUNT_ADD, component: ClientAccountEdit },
  { path: PATH_CLIENT_ACCOUNT_EDIT + ":clientAccountId", component: ClientAccountEdit }
]
export { clientRoutes }
